module.exports = "/images/disclosure_status_sprite_retina.png?1c5626eac0bc4ef8532871185d2853a9";